import { Subject } from 'rxjs'
import { flog } from '@zambezi/caballo-vivo'
import createIntentSubject$ from '@apiEnabler/api-enabler-common/lib/intent-subject'

export const displayBiometrics$ = new Subject().pipe(
  flog('Get biometrics consents')
)

export const displayMortgages$ = new Subject().pipe(
  flog('Get mortgage consents')
)

export const displayPayments$ = new Subject().pipe(flog('Get payments list'))
export const displayPaymentDetails$ = new Subject().pipe(
  flog('Get payment details')
)

export const displaySOPayments$ = new Subject().pipe(
  flog('Get standing order payments list')
)
export const displaySOPaymentDetails$ = new Subject().pipe(
  flog('Get standing order payment details')
)

export const displayFundsChecks$ = new Subject().pipe(
  flog('Get funds checks list')
)

export const displayFundsChecksForTpp$ = new Subject().pipe(
  flog('Get funds checks list for specific tpp')
)
export const displayFundsCheckDetails$ = new Subject().pipe(
  flog('Get funds check details')
)

export const cancelFundsCheck$ = new Subject().pipe(flog('Cancel funds check'))
export const ceaseCancelFundsCheck$ = createIntentSubject$().pipe(
  flog('Cease Cancel funds check')
)
export const confirmCancelFundsCheck$ = createIntentSubject$().pipe(
  flog('Confirm cancel funds check')
)

export const displayAccesses$ = new Subject().pipe(flog('Get accesses list'))
export const displayAccessesForTpp$ = new Subject().pipe(
  flog('Get accesses list for specific tpp')
)
export const displayAccessDetails$ = new Subject().pipe(
  flog('Get access details')
)

export const cancelAccess$ = new Subject().pipe(flog('Cancel access'))
export const ceaseCancelAccess$ = createIntentSubject$().pipe(
  flog('Cease cancel access')
)

export const confirmCancelAccess$ = createIntentSubject$().pipe(
  flog('Confirm cancel access')
)

export const displayVrp$ = new Subject().pipe(flog('Get Vrp list'))
export const displayVrpForTpp$ = new Subject().pipe(
  flog('Get Vrp list for specific tpp')
)
export const displayVrpDetails$ = new Subject().pipe(flog('Get Vrp details'))

export const cancelVrp$ = new Subject().pipe(flog('Cancel Vrp'))
export const ceaseCancelVrp$ = createIntentSubject$().pipe(
  flog('Cease cancel Vrp')
)

export const confirmCancelVrp$ = createIntentSubject$().pipe(
  flog('Confirm cancel Vrp')
)

export const displaySweeping$ = new Subject().pipe(flog('Get Sweeping list'))
export const displaySweepingForTpp$ = new Subject().pipe(
  flog('Get Sweeping list for specific tpp')
)
export const displaySweepingDetails$ = new Subject().pipe(
  flog('Get Sweeping details')
)

export const cancelSweeping$ = new Subject().pipe(flog('Cancel Sweeping'))
export const ceaseCancelSweeping$ = createIntentSubject$().pipe(
  flog('Cease cancel Sweeping')
)

export const confirmCancelSweeping$ = createIntentSubject$().pipe(
  flog('Confirm cancel Sweeping')
)

export const displayPayYou$ = new Subject().pipe(flog('Get PayYou things'))
export const displayPayYouLinkHistory$ = new Subject().pipe(
  flog('Navigate to PayYou Link History')
)
export const displayPayMe$ = new Subject().pipe(flog('Get PayMe things'))
export const displayPayMeLinkHistory$ = new Subject().pipe(
  flog('Navigate to PayMe Link History')
)
export const displayPayMeReusableLinkHistory$ = new Subject().pipe(
  flog('Navigate to PayMe Reusable Link History')
)

export const cancelLink$ = new Subject().pipe(flog('Cancel link'))
export const ceaseCancelLink$ = createIntentSubject$().pipe(
  flog('Cease cancel link')
)

export const confirmCancelLink$ = createIntentSubject$().pipe(
  flog('Confirm cancel link')
)

export const incrementGenerationPayMe$ = new Subject().pipe(
  flog('Pay Me Incrementer')
)

export const incrementGenerationPayYou$ = new Subject().pipe(
  flog('Pay You Incrementer')
)
